<div class="date-range-filter">
  <mat-form-field appearance="outline" class="date-range-field">
    <mat-label>{{ label() }}</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Start date" />
      <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  @if (showQuickFilters()) {
    <div class="quick-filters">
      @for (option of quickDateOptions(); track option.label) {
        <button
          mat-button
          type="button"
          (click)="setQuickDateRange(option.months)"
          class="quick-filter-btn"
        >
          {{ option.label }}
        </button>
      }
    </div>
  }

  @if (hasDateRange()) {
    <button
      mat-icon-button
      type="button"
      (click)="clearDateRange()"
      class="clear-button"
      matTooltip="Clear date range"
    >
      <mat-icon>clear</mat-icon>
    </button>
  }
</div>
